import { render } from "./DropdownComp.vue?vue&type=template&id=20c18c92&scoped=true&ts=true"
import script from "./DropdownComp.vue?vue&type=script&lang=ts"
export * from "./DropdownComp.vue?vue&type=script&lang=ts"

import "./DropdownComp.vue?vue&type=style&index=0&id=20c18c92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c18c92"]])

export default __exports__